import { OfficesPage } from "./OfficesPage";
export default OfficesPage;
